import axios from "axios";
import qs from "qs";
const initialState = {
    blogArticle: {
        title: "",
        abstract: "",
        body: "",
        json: {},
        html: "",
        category: "kolkin",
    },
    categories: [],
    blogArticles: [],
    blogArticleCount: 0,
	searchOpen: false,
};
export const state = { ...initialState };
export const actions = {
    async loadBlogArticle(context,id){
        return axios.get('/api/blog/article',{params:{id:id}}).then(function(response){
            context.commit('blogArticleSet',response.data);
        });
    },
    resetArticle(context){
        context.commit('articleClear');
    },
    async loadCategories(context){
        return axios.get("/api/blog/category").then(function(response){
            context.commit("setCategories",response.data)
        })
    },
    async loadBlogArticles(context,params){
        return axios.get("/api/blog/articles",{params: params, 
        paramsSerializer(params){
            var result = qs.stringify(params,{arrayFormat: "brackets"});
            return result
            }
        }).then(function(response){
            context.commit("setBlogArticles",response.data.articles);
            context.commit("setBlogArticleCount",response.data.count);
        })
    },
    async loadMoreBlogArticles(context,params){
        return axios.get("/api/blog/articles",{params: params, 
        paramsSerializer(params){
            var result = qs.stringify(params,{arrayFormat: "brackets"});
            return result
            }
        }).then(function(response){
            context.commit("appendBlogArticles",response.data.articles);
            context.commit("setBlogArticleCount",response.data.count);

        })
    },

	toggleSearchOpen(context){
		context.commit("setSearchOpen",!state.searchOpen);
	},

}

export const mutations = {

    articleClear(state){
        state.blogArticle =  {
            title: "",
            abstract: "",
            body: "",
            json: {},
            html: "",
            category: "kolkin",
            color: "primary",
        };
    },

    blogArticleSet(state, article){
        state.blogArticle = article;
        if(article.json){
            state.blogArticle.json = JSON.parse(article.json)
        }
        
    },

    articleUpdate(state, articleUpdate) {

        state.blogArticle.title = articleUpdate.title;
        state.blogArticle.abstract = articleUpdate.abstract;
        state.blogArticle.body = articleUpdate.body;
        state.blogArticle.json = articleUpdate.json;
        state.blogArticle.html = articleUpdate.html;


    },

    setCategories(state, data){
        state.categories = data;
    },

    setBlogArticles(state, data){
        state.blogArticles = data;
    },
    
    setBlogArticleCount(state,data){
        state.blogArticleCount = data;
    },

    appendBlogArticles(state,data){
        state.blogArticles = state.blogArticles.concat(data);
    },

    setCategory(state,data){
        state.blogArticle.category = data;
    },

	setSearchOpen(state,value){
		state.searchOpen = value;
	},

}

const getters = {
    blogArticle(state){
        return state.blogArticle;
    },

    blogArticleCount(state){
        return state.blogArticleCount;
    },

    blogArticles(state){
        return state.blogArticles;
    },

    categories(state){
        return state.categories;
    },

	searchOpen(state){
		return state.searchOpen;
	},
};

export default {
    state,
    actions,
    mutations,
    getters
  };
  